import Vue from 'vue'

export default {
  get (id, config = {}) {
    return Vue.http.get(`/licensor/reports/${id}`, {
      ...config
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/licensor/report.js